export default {
  services: {
    portal: {
      available: true,
      superuser: true,
    },
    maps: {
      available: false,
      superuser: true,
    },
    geocontrib: {
      available: true,
      superuser: true,
    },
    stats: {
      available: false,
      superuser: true,
    },
    geoserver: {
      available: false,
      superuser: true,
    },
    geonetwork: {
      available: false,
      superuser: true,
    },
    majic: {
      available: true,
      superuser: true,
    },
  },
  itemsPerPage: {
    datasets: 20,
    jurisdictions: 50
  },
  forms: {
    user: {
      hiddenFields: [],
      requiredFields: [
        'last_name',
        'first_name',
        'email'
      ]
    },
    organisation: {
      hiddenFields: [],
      requiredFields: [
        'display_name',
        'organisation_type'
      ]
    },
    group: {
      hiddenFields: [],
      requiredFields: [
        'name'
      ]
    },
    sphere: {
      hiddenFields: [],
      requiredFields: [
        'name'
      ]
    },
    contact: {
      hiddenFields: [],
      requiredFields: [
        'name',
        'email'
      ]
    },
    dataset: {
      hiddenFields: [],
      requiredFields: [
        'display_name',
        'description',
        'keywords',
        'topics',
        'kinds',
        'usergroup',
        'publication_date',
        'last_update_date',
        'update_frequency',
        'record_type',
      ],
      extraFields: [
        // For e.g.
        {
          title: {
            en: 'Datavisualisation',
            fr: 'Datavisualisation',
          },
          icon: 'dataviz',
          fields: [
            {
              key: 'dataviz_href',
              label: {
                en: 'URL',
                fr: 'URL',
              },
              help: {
                en: 'Enter the URL of the Datavisualization to reference',
                fr: 'Entrer l\'url de la Datavisualisation à référencer'
              }
            },
          ]
        },
      ],
    },
    resource: {
      datastore: {
        superuserOnly: false,
        hiddenFields: [],
        requiredFields: [
          'display_name',
        ]
      },
      'file-upload': {
        superuserOnly: false,
        hiddenFields: [],
        requiredFields: [
          'display_name',
          'column_x',
          'column_y',
          'crs'
        ]
      },
      ftp: {
        superuserOnly: false,
        hiddenFields: [],
        requiredFields: [
          'display_name',
        ]
      },
      'file-download': {
        superuserOnly: false,
        hiddenFields: [],
        requiredFields: [
          'display_name',
        ]
      },
      href: {
        superuserOnly: false,
        hiddenFields: [],
        requiredFields: [
          'display_name',
        ]
      },
      geoserver: {
        superuserOnly: false,
        hiddenFields: [
        ],
        requiredFields: [
          'display_name',
        ]
      }
    },
    indexer: {
      hiddenFields: [],
      requiredFields: [
        'name',
        'url',
        'command',
        'scheduler',
      ]
    }
  },
  resourceTypes: [
    'file-upload',
    'file-download',
    'ftp',
    'href',
    'datastore',
    'geoserver'
  ],
  annexTypes: [
    'file-upload',
    'file-download',
    'ftp',
    'href',
  ],
  wms: {
    staticBaseUrl:'https://www.datasud.fr/maps'
  }
};
